import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  CircularProgress,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { addBlog, fetchSpecialtiesList } from "../../Adapters/ApiAdapter";
import { baseUrl } from "../../variables/Variables";
// import { useNavigate } from "react-router-dom";
import SeoTags from "../SeoTags/SeoTags";
import CKEditorField from "../../components/CKEditorField";

const AddBlog = () => {
  const [formData, setFormData] = useState({
    title: "",
    slug: "",
    category: "",
    content: "",
    source_page: "",
    status: "",
    speciality_id: "",
    seo_title: "",
    meta_title: "",
    meta_description: "",
    meta_keywords: "",
    custom_scripts: "",
    og_title: "",
    og_description: "",
    og_type: "",
    og_url: "",
    og_image: "",
    og_locale: "",
    og_site_name: "",
    og_image_width: "",
    og_image_height: "",
    og_image_type: "",
    article_modified_time: "",
    canonical_link: "",
    twitter_card: "",
    twitter_site: "",
    twitter_title: "",
    twitter_description: "",
    twitter_image: "",
    featured_img: null,
    banner_img: null,
  });
  const [featuredImg, setFeaturedImg] = useState(null);
  const [bannerImgFile, setBannerImgFile] = useState(null);
  const [twitterImgFile, setTwitterImgFile] = useState(null);
  const [ogImgFile, setOgImgFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [specialities, setSpecialities] = useState([]);
  const [loadingSpecialities, setLoadingSpecialities] = useState(true);
  const [seoFormData, setSeoFormData] = useState(formData);

  // const navigate = useNavigate();
  // const [resetSeoTags, setResetSeoTags] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchSpecialtiesList();
        if (response && response.specialities) {
          setSpecialities(response.specialities);
        } else {
          toast.error("Failed to load specialities.");
        }
      } catch (error) {
        toast.error("Error fetching specialities.");
      } finally {
        setLoadingSpecialities(false);
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      let updatedForm = { ...prev, [name]: value };

      if (name === "title") {
        updatedForm.slug = generateSlug(value);
      }

      return updatedForm;
    });
  };

  const handleFileChange = (e, key, setPrevieState) => {
    const file = e.target.files[0];
    if (file) {
      setPrevieState(file);
      setFormData((prev) => ({
        ...prev,
        [key]: file,
      }));
    }
  };

  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/&/g, " ")
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const blogData = new FormData();

    // const stripHtml = (html) => html.replace(/<[^>]+>/g, "").trim();

    blogData.append("title", formData.title);
    blogData.append("slug", formData.slug);
    blogData.append("category", formData.category);
    blogData.append("content", formData.content);
    blogData.append("source_page", formData.source_page);
    blogData.append("status", formData.status);
    blogData.append("speciality_id", formData.speciality_id);
    blogData.append("seo_title", formData.seo_title);
    blogData.append("meta_title", formData.meta_title);
    blogData.append("meta_description", formData.meta_description);
    blogData.append("meta_keywords", formData.meta_keywords);
    blogData.append("custom_scripts", formData.custom_scripts);
    blogData.append("og_title", formData.og_title);
    blogData.append("og_description", formData.og_description);
    blogData.append("og_type", formData.og_type);
    blogData.append("og_url", formData.og_url);
    blogData.append("og_locale", formData.og_locale);
    blogData.append("og_site_name", formData.og_site_name);
    blogData.append("og_image_width", formData.og_image_width);
    blogData.append("og_image_height", formData.og_image_height);
    blogData.append("og_image_type", formData.og_image_type);
    blogData.append("article_modified_time", formData.article_modified_time);
    blogData.append("canonical_link", formData.canonical_link);
    blogData.append("twitter_card", formData.twitter_card);
    blogData.append("twitter_site", formData.twitter_site);
    blogData.append("twitter_title", formData.twitter_title);
    blogData.append("twitter_description", formData.twitter_description);

    if (formData.featured_img) {
      blogData.append("featured_img", formData.featured_img);
    }
    if (formData.banner_img) blogData.append("banner_img", formData.banner_img);
    if (formData.twitter_image)
      blogData.append("twitter_image", formData.twitter_image);
    if (formData.og_image) blogData.append("og_image", formData.og_image);

    if (featuredImg) blogData.append("featured_img", featuredImg);
    if (bannerImgFile) blogData.append("banner_img", bannerImgFile);
    if (twitterImgFile) blogData.append("twitter_image", twitterImgFile);
    if (ogImgFile) blogData.append("og_image", ogImgFile);

    try {
      const response = await addBlog(blogData);
      console.log("Blog AOI Res: ", response);
      if (response && response.status === "true") {
        toast.success("Blog added successfully!");
        setFormData({
          title: "",
          slug: "",
          category: "",
          content: "",
          source_page: "",
          status: "",
          speciality_id: "",
          seo_title: "",
          meta_title: "",
          meta_description: "",
          meta_keywords: "",
          custom_scripts: "",
          og_title: "",
          og_description: "",
          og_type: "",
          og_url: "",
          og_image: "",
          og_locale: "",
          og_site_name: "",
          og_image_width: "",
          og_image_height: "",
          og_image_type: "",
          article_modified_time: "",
          canonical_link: "",
          twitter_card: "",
          twitter_site: "",
          twitter_title: "",
          twitter_description: "",
          twitter_image: "",
        });
        setFeaturedImg(null);
        setBannerImgFile(null);
        setTwitterImgFile(null);
        setOgImgFile(null);

        setSeoFormData({});
      } else {
        toast.error("Failed to add blog. Please try again...");
      }
    } catch (error) {
      console.error("Error adding blog:", error);
      toast.error("Failed to add blog. Please try again.");
    } finally {
      setLoading(false);
    }
    console.log(Object.fromEntries(blogData.entries()));
  };

  // const handleSubmit = async () => {
  //   if (!title || !category || !content) {
  //     toast.error("Title, Category, and Content are required!");
  //     return;
  //   }

  //   setLoading(true);

  //   const formData = new FormData();
  //   formData.append("title", title);
  //   if (slug) formData.append("slug", slug);
  //   formData.append("category", category);
  //   formData.append("content", content);
  //   if (featuredImg) formData.append("featured_img", featuredImg);
  //   formData.append("source_page", sourcePage);
  //   formData.append("status", status);

  //   try {
  //     const response = await addBlog(formData);
  //     if (response.status === "success") {
  //       toast.success("Blog added successfully!");
  //       setTimeout(() => navigate("/blogs"), 2000); // Redirect after success
  //     } else {
  //       toast.error(
  //         response.message || "Failed to add blog. Please try again."
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error adding blog:", error);
  //     toast.error("Failed to add blog. Please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  return (
    <Box m="20px">
      <ToastContainer />
      <Typography variant="h4" gutterBottom>
        Add Blog
      </Typography>
      <Box
        display="flex"
        flexDirection="column"
        gap="16px"
        maxWidth="600px"
        mt="20px"
      >
        <TextField
          fullWidth
          margin="normal"
          label="Title"
          // variant="outlined"
          value={formData.title}
          onChange={handleInputChange}
          name="title"
          required
        />
        <TextField
          fullWidth
          margin="normal"
          label="Slug"
          name="slug"
          // variant="outlined"
          value={formData.slug}
          onChange={handleInputChange}
        />

        <FormControl fullWidth>
          <InputLabel>Category</InputLabel>
          <Select
            name="category"
            value={formData.category}
            // onChange={(e) => handleInputChange(e.target.value)}
            onChange={handleInputChange}
            required
          >
            <MenuItem value="Tech">Tech</MenuItem>
            <MenuItem value="Health">Health</MenuItem>
            <MenuItem value="Lifestyle">Lifestyle</MenuItem>
          </Select>
        </FormControl>

        <Typography variant="body1">Content</Typography>
	  {/* <ReactQuill
          theme="snow"
          value={formData.content}
          onChange={(value) => setFormData({ ...formData, content: value })}
          style={{ height: "200px", marginBottom: "20px" }}
        /> */}
	  <Box sx={{ ".ck-editor__editable_inline": { minHeight: "250px" } }}>
          <CKEditorField
            value={formData.content}
            onChange={(data) => setFormData({ ...formData, content: data })}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=blogs`}
          />
        </Box>

        {/* <TextField
          fullWidth
          margin="normal"
          label="Source Page"
          name="source_page"
          value={formData.source_page}
          onChange={handleInputChange}
        /> */}
        <FormControl fullWidth>
          <InputLabel>Status *</InputLabel>
          <Select
            name="status"
            value={formData.status}
            // onChange={(e) => handleInputChange(e.target.value)}
            onChange={handleInputChange}
            required
          >
            <MenuItem value="publish">Publish</MenuItem>
            <MenuItem value="draft">Draft</MenuItem>
          </Select>
        </FormControl>

        {loadingSpecialities ? (
          <CircularProgress size={24} />
        ) : (
          <FormControl fullWidth margin="normal">
            <InputLabel id="speciality-label">Speciality</InputLabel>
            <Select
              labelId="speciality-label"
              name="speciality_id"
              value={formData.speciality_id}
              onChange={handleInputChange}
              required
            >
              {specialities.map((speciality) => (
                <MenuItem key={speciality.id} value={speciality.id}>
                  {speciality.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <SeoTags
          formData={formData}
          setFormData={setFormData}
          setTwitterImgFile={setTwitterImgFile}
          setOgImgFile={setOgImgFile}
          setBannerImgFile={setBannerImgFile}
        />

        <Box mt={2}>
          <Button variant="contained" component="label">
            Upload Featured Image
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={(e) =>
                handleFileChange(e, "featured_img", setFeaturedImg)
              }
            />
          </Button>
          {featuredImg && (
            <Typography
              variant="body2"
              mt={1}
              style={{ marginTop: "10px", fontStyle: "italic" }}
            >
              Selected File : {featuredImg.name}
            </Typography>
          )}
        </Box>
        <Box mt={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : "Add Blog"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AddBlog;
